import * as moment from 'moment';
import * as angular from 'angular';
class DateTimePickerController implements ng.IComponentController {
    previousDate: any;
    addClass: any;
    classes: any;
    private minDate: any;
    private maxDate: any;
    private onChange: any;
    private timeformat: string;
    private dateformat: string;
    private date: any;
    private time: boolean = true;
    constructor(
        private $element: ng.IRootElementService,
        private $attrs: ng.IAttributes,
        private $timeout: ng.ITimeoutService
    ) {
        'ngInject';
    }

    public $onInit = () => {

        if (!this.$attrs.time) {
            this.time = true;
        }

        this.previousDate = angular.copy(this.date);

        (<any>$(this.$element).find('.datepicker').datepicker)({
            format: 'dd-mm-yyyy',
            language: 'nl',
            autoclose: true,
        });

        this.$timeout(() => {

            $(this.$element).find('.open-datetimepicker').click((event) => {
                event.preventDefault();
                $(this.$element).find('.datepicker').datepicker('show');
            });

            $(this.$element).find('.timepickerinput').timepicker({
                showMeridian: false,
                minuteStep: 5
            }).on('hide.timepicker', (e) =>  {
                this.$timeout(() => {
                    this.setTime()
                });
            });

            this.dateformat = moment(this.date).format('DD-MM-YYYY');
            this.timeformat = moment(this.date).format('HH:mm');
            $(this.$element).find('.datepicker').datepicker('setDate', this.dateformat);
            $(this.$element).find('.timepickerinput').timepicker('setTime', this.timeformat);
            this.checkMinDate();
        });

        this.classes = this.addClass;
    }

    public $doCheck = () => {

        if (!angular.equals(this.date, this.previousDate)) {
            // console.log('previousDate', this.previousDate)
            this.dateformat = moment(this.date).format('DD-MM-YYYY');
            this.timeformat = moment(this.date).format('HH:mm');
            $(this.$element).find('.timepickerinput').timepicker('setTime', this.timeformat);
            if(this.previousDate){
                $(this.$element).find('.datepicker').datepicker('setDate', this.dateformat);
            }
            this.previousDate = angular.copy(this.date);
            this.$timeout(() => {
                this.checkMinDate();
            });
        }

    }

    public $onChanges = (changes) => {
      
        if(changes.minDate && changes.minDate.previousValue.constructor.name != 'UNINITIALIZED_VALUE') {

            this.$timeout(() => {
                this.checkMinDate();
            });
        }
    }

    private checkMinDate = () => {
        if (this.minDate && this.date) {
            //console.log(moment(this.date).format('DD-MM-YYYY'));
            //console.log(this.minDate);
            // if (moment(this.minDate).isAfter(this.date)) {
            //     this.date = moment(this.minDate).add(1, 'hour');
            //     this.dateformat = moment(this.date).format('DD-MM-YYYY');
            //     this.timeformat = moment(this.date).format('HH:mm');
            //     $(this.$element).find('.datepicker').datepicker('setDate', this.dateformat);
            // }
            $(this.$element).find('.datepicker').datepicker('setStartDate', moment(this.minDate).format('DD-MM-YYYY'));
        }
    }

    private setDate = () => {
        if (this.dateformat && this.timeformat) {
            if (this.time) {
                this.date = moment(this.dateformat + ' ' + this.timeformat, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DDTHH:mm:ss');
            } else {
                this.date = moment(this.dateformat, 'DD-MM-YYYY').format('YYYY-MM-DD');
            }
            this.$timeout(() => { this.onChange(); });
        }
    }

    private setTime = () => {
        if (this.dateformat && this.timeformat) {
            this.date = moment(this.dateformat + ' ' + this.timeformat, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DDTHH:mm:ss');
            this.$timeout(() => { this.onChange(); });
        }
    }
}

export const dateTimePickerComponent: ng.IComponentOptions = {
    bindings: {
        date: '=',
        time: '<',
        maxDate: '<',
        minDate: '<',
        onChange: '&',
        addClass: '<',
        disabled: '<'
    },
    controller: DateTimePickerController,
    template: require('./dateTimePicker.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shared/dateTimePicker.component.ts